import { useQuery } from '@tanstack/react-query'

import { useAuthenticatedUser } from '../../auth/hooks/useAuthenticatedUser'
import {
  fetchDeelnemerValuelists,
  initialState,
} from '../services/fetchDeelnemerValuelists'

export { useDeelnemerValuelists }

const queryKey = 'valuelists-deelnemer'

const useDeelnemerValuelists = () => {
  const { hasPermissions } = useAuthenticatedUser()

  const { data } = useQuery({
    queryFn: fetchDeelnemerValuelists,
    queryKey: [queryKey],
    enabled: hasPermissions,
  })

  return {
    data: data || initialState.data,
  }
}
